module.exports = __webpack_public_path__ + "img/267-2.c3b7e67b.jpg";